<template>
  <div @click="$emit('click')">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5682 15.5647C13.5364 15.0758 15.0628 13.5488 15.5515 11.5797C15.8527 10.3943 16 9.18877 16 8.00334C16 6.81791 15.8527 5.61239 15.5582 4.42695C15.0695 2.45793 13.5431 0.930933 11.5682 0.442025C9.19833 -0.147342 6.79498 -0.147342 4.42511 0.442025C2.4569 0.930932 0.930545 2.45793 0.441842 4.42695C0.14728 5.60569 -2.97728e-07 6.81121 -3.49544e-07 7.99664C-4.01361e-07 9.18208 0.14728 10.3876 0.441842 11.5663C0.930544 13.5354 2.4569 15.0624 4.4251 15.5513C6.80167 16.1473 9.20502 16.1473 11.5682 15.5647ZM5.26862 12.1825C4.5523 12.0017 3.99665 11.4458 3.82259 10.7359C3.36736 8.91418 3.36736 7.0925 3.82259 5.27082C4.00335 4.5542 4.559 3.99832 5.26862 3.82419C7.08954 3.36877 8.91046 3.36877 10.7314 3.82419C11.4477 4.00502 12.0033 4.5609 12.1774 5.27082C12.6326 7.0925 12.6326 8.91418 12.1774 10.7359C11.9967 11.4525 11.441 12.0084 10.7314 12.1825C8.91046 12.6312 7.08954 12.6312 5.26862 12.1825Z"
        :fill="active ? '#FEEA01' : '#646464'"
      />
    </svg>
  </div>
</template>

<script>
  export default {
    props: {
      active: {
        type: Boolean,
        default: false,
        required: false
      }
    }
  };
</script>

<style lang="scss" scoped>
  div {
    height: 16px;
    font-size: 0;
    line-height: 0;
  }
  svg {
    width: 16px;
    height: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CounterMarks/components/MarkItem.vue